export const POLICY_TERMS_URL = 'https://about.teamrwb.org/policy-terms';

export const COMMUNITY_GUIDELINES_URL = 'https://about.teamrwb.org/community-guidelines/';
